var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoodFill2 = function SvgMoodFill2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51.052,
    height: 51.052,
    viewBox: "0 0 51.052 51.052",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_721",
    "data-name": "Caminho 721",
    d: "M101.072,1.784A25.52,25.52,0,1,1,86.7,34.889a25.522,25.522,0,0,1,14.372-33.1Zm23.535,32.609a1.7,1.7,0,0,1-3.054,1.474,12.361,12.361,0,0,0-22.229,0,1.7,1.7,0,0,1-3.054-1.474,15.759,15.759,0,0,1,28.337,0Z",
    transform: "translate(-84.913 0.003)",
    fillRule: "evenodd",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoodFill2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moodFill2.e65833a4.svg";
export { ForwardRef as ReactComponent };